import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const InfoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M0 10C0 4.47714 4.47705 0 10 0C15.5229 0 20 4.47714 20 10C20 15.5229 15.5229 20 10 20C4.47705 20 0 15.5229 0 10ZM2 10C2 5.58173 5.58179 2 10 2C14.4182 2 18 5.58173 18 10C18 14.4183 14.4182 18 10 18C5.58179 18 2 14.4183 2 10ZM11.6819 5.10977L9.07739 5.10977L9.44312 11.5766L11.3196 11.5766L11.6819 5.10977ZM9.20386 14.9091L11.5554 14.9091L11.5554 12.6396L9.20386 12.6396L9.20386 14.9091Z"
        clipRule="evenodd"
        fill="currentColor"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
